import useOnClickOutside from '../../hooks/useClickOutside'
import classNames from 'classnames'
import React, { ReactNode, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { CSSTransition } from 'react-transition-group'
import { getIconByName } from '../../icons'
import Blanket from '../Blanket/Blanket'
import Icon from '../Icon/Icon'
import styles from './Dialog.module.scss'

const duration = 1500
export type DialogProps = {
  children: ReactNode
  onClose?: (isOpen: boolean) => void
  className?: string
  isOpen?: boolean
  hasGradient?: boolean
  theme?: string
  style?: React.CSSProperties
}
const Dialog = (props: DialogProps): JSX.Element | null => {
  const {
    children,
    isOpen,
    className,
    onClose,
    hasGradient = true,
    theme = 'light',
    style,
  } = props
  const ref = useRef(null)
  const blanketRef = useRef(null)
  const dialogContainerRef = useRef(null)

  useOnClickOutside(dialogContainerRef, () => {
    onClose && onClose(false)
  })

  useEffect(() => {
    if (isOpen) {
      document.querySelector('body')?.classList.add('remove-scroll')
    }
    return () => {
      if (isOpen) {
        document.querySelector('body')?.classList.remove('remove-scroll')
      }
    }
  }, [isOpen])

  return isOpen
    ? ReactDOM.createPortal(
        <>
          <CSSTransition
            ref={blanketRef}
            in={isOpen}
            timeout={duration}
            appear={isOpen}
            unmountOnExit={true}
            classNames="fade-in"
          >
            <Blanket />
          </CSSTransition>
          <CSSTransition
            nodeRef={ref}
            in={isOpen}
            timeout={0}
            appear={isOpen}
            classNames="slide-up"
          >
            <div
              className={classNames(styles.container, {
                [styles.hasGradient]: hasGradient,
              })}
              ref={ref}
            >
              <div
                ref={dialogContainerRef}
                style={style}
                className={classNames(
                  styles.dialog,
                  styles[`theme__${theme}`],
                  className
                )}
              >
                <button
                  onClick={() => onClose && onClose(!isOpen)}
                  className={styles.close}
                >
                  <Icon size={24} icon={getIconByName('times')} />
                </button>
                {children}
              </div>
            </div>
          </CSSTransition>
        </>,
        document.querySelector('#portal') as HTMLDivElement
      )
    : null
}

export default Dialog
